import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Component({
  standalone: true,
  imports: [RouterOutlet],
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly loggingService = inject(LoggingService);

  constructor() {
    this.loggingService.warn('NG_APP_ENV', import.meta.env.NG_APP_ENV);
  }
}
